import AuditActions from "actions/AuditActions";
import LocalStorageKeys from "const/LocalStorageKeys";
import Storage from "utils/Storage";

const { AUDIT_FILTERS } = LocalStorageKeys;

export default () => {
  return (next) => (action) => {
    const { type, payload } = action;

    const result = next(action);

    if (type === AuditActions.SET_COMPANY_FILTERS) {
      const { selectedBusinessId, filters } = payload;

      const stored = Storage.storageJsonValue(AUDIT_FILTERS) || {};

      Storage.storageJsonValue(AUDIT_FILTERS, {
        ...stored,
        [selectedBusinessId]: filters
      });
    }

    return result;
  };
};
